import React from "react";
import styled from "styled-components";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Row = styled.div`
  display: flex;
  align-items: center;

  max-width: 400px;
  gap: 1rem;
`;

interface SuccessActionsProps {
  reportId: number;
}

const SuccessActions: React.FC<SuccessActionsProps> = ({
  reportId,
}: SuccessActionsProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleMoveToReport = () => {
    navigate(`/view-report/${reportId}`);
  };

  const handleClose = () => {
    navigate("/reporting");
  };

  return (
    <Row style={{ marginTop: "2rem" }}>
      <Button
        style={{ marginLeft: "2rem" }}
        outlined
        label={t("cmd-inspect-report")}
        onClick={handleMoveToReport}
      />
      <Button label={t("cmd-close")} onClick={handleClose} />
    </Row>
  );
};

export default SuccessActions;
